/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Container, Card, Stack, TextField, IconButton, Button, Box, Grid, 
    MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
    Paper, Chip, TableFooter, TablePagination
} from '@mui/material';
import { Edit as EditIcon,FirstPage as FirstPageIcon, KeyboardArrowLeft, KeyboardArrowRight, LastPage as LastPageIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import services from '../Services';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import { LoadingComponent } from 'src/pages/pageLoader';
import PropTypes from 'prop-types';
import xlsx from 'json-as-xlsx';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function OrderAllocationConfigurationListing(props) {
    const screenCode = 'ORDERALLOCATIONCONFIGURATION';
    let encrypted = "";
    const navigate = useNavigate();
    const [groupList, setGroupList] = useState([]);
    const [grades, setGrades] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [formData, setFormData] = useState({
        groupID: "0",
        gradeID: "0",
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required')
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            gradeID: formData.gradeID,
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetOrderAllocationConfigurationData(values));
        },
    });
    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('Order Allocation Configuration-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            GetOrderAllocationConfigurationData();
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'Order Allocation Configuration-page-search-parameters-id'
        );
    }, []);

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        GetGradeByGroupID();
    }, [values.groupID]);

    async function getPermissions(IDdata) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWORDERALLOCATIONCONFIGURATION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        const initialValues = IDdata === null;
        if (initialValues) {
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
        }else{
            setValues({
                ...values,
                groupID: IDdata.groupID,
                gradeID: IDdata.gradeID
            });
        }
        setIsIDDataForDeduction(IDdata);
    }
    
    async function GetAllGroups() {
        var res = await services.GetAllGroups();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetGradeByGroupID() {
        var res = await services.GetGradeByGroupID(values.groupID);
        if (res != null) {
            setGrades(res);
        }
    }

    async function GetOrderAllocationConfigurationData() {
        let model = {
            groupID: parseInt(values.groupID),
            gradeID: parseInt(values.gradeID),
        }
        var res = await services.GetOrderAllocationConfigurationData(model);
        if (res.statusCode == "Success") {
            setTableData(res.data);
        }else{
            toast.error("No Records to Display");
        }
    }

    async function clearAll() {
        setValues({
            ...values,
            gradeID: "0",
        })
        setTableData([]);
    }

    const handleClear = () => {
        setTableData([]);
    };

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        if (name === "groupID") {
                setValues({
                ...values,
                [name]: value,
                gradeID: "0",
            });
        } else {
                setValues({
                ...values,
                [name]: value
              });
        }
        setTableData([]);
    }

    async function handleClick(datas) {
        encrypted = await AESEncryptionParam(datas.toString());
        let model = {
            groupID: parseInt(values.groupID),
            gradeID: parseInt(values.gradeID),
        }
        sessionStorage.setItem('Order Allocation Configuration-page-search-parameters-id', JSON.stringify(model));
        navigate('/dashboard/OrderAllocationConfiguration/AddEdit/' + encrypted)
    }
    
    async function createDataForExcelTransaction(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Outlet Name': x.factoryName || '-',
                    'Grade': x.gradeName || '-',
                    'Priority': x.priority || '-',
                    'Fill Rate': x.fillRate + '%' ||'-',
                    'Status': x.isActive == 1 ? 'Active' : 'Inactive' || '-',
                }
                res.push(vr);
                });
                res.push({                    
                    'Grade': '',                    
                    'Priority': '',                    
                    'Fill Rate': '',  
                    'Status': '',                                    
                    });

        }
        return res;
    }

    async function createFile() {    
        var file = await createDataForExcelTransaction(tableData);    
        var settings = {        
            sheetName: 'Order Allocation Details',        
            fileName: 'Order Allocation Configuration Details '+ groupList.find(x => x.groupID == values.groupID).groupName,
            writeOptions: {}    
        };    
        let keys = Object.keys(file[0]);    
        let tempcsvHeaders = [];    
        keys.map((sitem) => {        
            tempcsvHeaders.push({ label: sitem, value: sitem });    
        });    
        let dataA = [        
            {            
                sheet: 'Order Allocation Details',            
                columns: tempcsvHeaders,            
                content: file        
            }    
        ];    
        xlsx(dataA, settings);    
    }
    
    return (
        <>
            <LoadingComponent />
            <Page title="Outlet |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/OrderAllocationConfiguration/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Order Allocation Configuration"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={(e) => {
                                                setTableData([]);
                                                setValues({
                                                    ...values,
                                                    gradeID: "0",
                                                });
                                                formik.setFieldValue('groupID', e.target.value);
                                            }}                                            
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Grade"
                                            value={formik.values.gradeID}
                                            onChange={(e) => {
                                                setTableData([]);
                                                formik.setFieldValue('gradeID', e.target.value);
                                            }}                                           
                                            error={Boolean(touched.gradeID && errors.gradeID)}
                                            helperText={touched.gradeID && errors.gradeID}
                                        >
                                            <MenuItem key={0} value={0}>All</MenuItem>
                                            {grades.map((option) => (
                                                <MenuItem key={option.gradeID} value={option.gradeID}>
                                                    {option.gradeName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <Grid item md={8} xs={12}>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                                <Button
                                                    type="button"
                                                    color='error'
                                                    variant="outlined"
                                                    onClick={() => clearAll()}
                                                > Clear</Button>
                                                <Button
                                                    type="submit"
                                                    color='secondary'
                                                    variant="outlined"
                                                >Search</Button>
                                            </Stack>
                                        </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Order Allocation Configuration" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell align="left" style={{ width: '20%' }}>Outlet Name</TableCell>
                                            <TableCell align="center" style={{ width: '20%' }}>Grade</TableCell>
                                            <TableCell align="center" style={{ width: '20%' }}>Priority</TableCell>
                                            <TableCell align="center" style={{ width: '20%' }}>Fill Rate</TableCell>
                                            <TableCell align="center" style={{ width: '20%' }}>Status</TableCell>
                                            <TableCell align="center" style={{ width: '25%' }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (                                                
                                                    <TableRow key={row.orderAllocationConfigurationID}>
                                                    <TableCell align="left" style={{ width: '20%' }}>{row.factoryName}</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }}>{row.gradeName}</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }}>{row.priorityName}</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }}>{row.fillRate}%</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }}>{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center" style={{ width: '20%' }} >
                                                        <IconButton onClick={() => handleClick(row.orderAllocationConfigurationID)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                    {tableData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem',backgroundColor: '#00AB55' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}